import { useState, useEffect } from 'react';
import { string, number } from 'prop-types';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import Button from '../../StoraEnsoComponents/Button';
import ConfirmationModal from '../../ConfirmationModal';
import NotificationToast from '../../NotificationToast';
import { changMultimediaTag} from '../../../services/multimediaService';
import { DRONE_MAP } from '../../../Routes';

const TAG_OPTIONS = [
  {label: 'unvalidated', value: 1},
  {label: 'internal', value: 2},
  {label: 'public', value: 3},
  {label: 'deleted', value: 4}
];

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 8px;

  @media screen and (min-width: 576px) {
    column-gap: 25px;
    grid-template-columns: 1fr auto;
    align-items: flex-end;
  }
`;

// TODO:
// - reload item after update action ??
// - implement custom styles for Select component
function TagMenu({id, tagId}) {
  const [tag, setTag]= useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [actionResult, setActionResult] = useState(null);


  const navigate = useNavigate();

  const isDeleteAction = () => tag.value === 4;

  const handleStatusUpdate = () => {
    if(isDeleteAction()){
     setModalOpen(true);
    } else {
      updateStatus();
    }
  }

  const updateStatus = () => {
    changMultimediaTag(tag.value, id)
      .then(() => {
        setActionResult({
          kind: 'success',
          message: 'The project status has been successfully updated.'
        });

        if(isDeleteAction()) {
          navigate(DRONE_MAP)
        }
      })
      .catch(() => {
        setActionResult({
          kind: 'error',
          message: 'An error has occurred while changing project status!'
        });
      });
  }

  useEffect(() => {
    setTag(TAG_OPTIONS.find(t => t.value === tagId));
  }, [tagId]);

  return (
    <>
      <NotificationToast
        toastId="projectStatusUpdate"
        kind={actionResult?.kind}
        message={actionResult?.message}
        onClose={() => setActionResult(null)}
      />
      <ConfirmationModal
        isOpen={isModalOpen}
        modalId="deleteConfirmation"
        kind="error"
        title="Project Delete"
        okBtnLabel="Confirm"
        onClose={() => setModalOpen(false)}
        onSubmit={() => {
          updateStatus();
          setModalOpen(false);
        }}
        >
          Do you really want to DELETE this project? This action can not be reversed.
      </ConfirmationModal>
      <Wrapper>
        <div id="tagMenu">
          <label htmlFor="tagId">Status</label>
          <Select
            inputId="tagId"
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            options={TAG_OPTIONS}
            value={tag}
            onChange={value => {
              setTag(value)
              console.log(value);

            }}
          />
        </div>
        <Button onClick={handleStatusUpdate}>
          SET STATUS
        </Button>
      </Wrapper>
    </>
  );
}

TagMenu.propTypes = {
  id: string.isRequired,
  tagId: number.isRequired,
}

export default TagMenu;